<script>
export default {
    props: {
        text: String,
        bold: Boolean,
        clazz: String,
    }
}
</script>

<template>
    <strong
        v-if="bold"
        style="white-space: nowrap;"
        :class="clazz"
    >
        {{ text }}
    </strong>
    <span
        v-else
        style="white-space: nowrap;"
        :class="clazz"
    >
        {{ text }}
    </span>
</template>

<style scoped>

</style>